import { useEffect, useRef, useState } from "react";
import { IDIOMAS_PROPIEDAD } from "../../constants/propiedadIdiomas";
import { usePropiedadIdioma } from "../../context/PropiedadIdiomaContext";

const FLAGS = {
  es: "🇪🇸", ca: "🏴", en: "🇬🇧", de: "🇩🇪", fr: "🇫🇷",
  nl: "🇳🇱", it: "🇮🇹", pl: "🇵🇱", ru: "🇷🇺", uk: "🇺🇦",
};

export default function SelectorIdiomaFicha({ isDark = false }) {
  const { idiomaVista, setIdiomaVista } = usePropiedadIdioma();
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);

  const actual = IDIOMAS_PROPIEDAD.find((i) => i.code === idiomaVista) || IDIOMAS_PROPIEDAD[0];
  const code = String(actual.code || "es").toUpperCase().slice(0, 2);

  useEffect(() => {
    if (!abierto) return undefined;
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAbierto(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [abierto]);

  return (
    <div ref={ref} style={{ position: "relative", flexShrink: 0 }}>
      <button
        type="button"
        onClick={() => setAbierto((v) => !v)}
        title={actual.label}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 3,
          padding: "5px 7px",
          minWidth: 0,
          borderRadius: 8,
          border: `1px solid ${isDark ? "#6366f1" : "#4338ca"}`,
          background: isDark ? "#312e81" : "#eef2ff",
          color: isDark ? "#e0e7ff" : "#4338ca",
          fontSize: 10,
          fontWeight: 800,
          cursor: "pointer",
          letterSpacing: "0.04em",
          lineHeight: 1,
        }}
      >
        <span aria-label={actual.label}>{code}</span>
        <span style={{ fontSize: 9, opacity: 0.65, lineHeight: 1 }}>{abierto ? "▲" : "▼"}</span>
      </button>
      {abierto && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            right: 0,
            minWidth: 180,
            background: isDark ? "#1e293b" : "#fff",
            border: `1px solid ${isDark ? "#334155" : "#e2e8f0"}`,
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
            zIndex: 50,
            overflow: "hidden",
          }}
        >
          {IDIOMAS_PROPIEDAD.map((i) => {
            const sel = i.code === idiomaVista;
            return (
              <button
                key={i.code}
                type="button"
                onClick={() => {
                  setIdiomaVista(i.code);
                  setAbierto(false);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  width: "100%",
                  padding: "10px 14px",
                  border: "none",
                  borderBottom: `1px solid ${isDark ? "#334155" : "#f1f5f9"}`,
                  background: sel ? (isDark ? "#312e81" : "#eef2ff") : "transparent",
                  color: isDark ? "#f1f5f9" : "#1e293b",
                  fontSize: 13,
                  fontWeight: sel ? 700 : 500,
                  cursor: "pointer",
                  textAlign: "left",
                }}
              >
                <span style={{ fontSize: 18 }}>{FLAGS[i.code] || "🌐"}</span>
                <span style={{ fontWeight: 700, minWidth: 28 }}>{i.code.toUpperCase().slice(0, 2)}</span>
                <span style={{ opacity: 0.85 }}>{i.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
